import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BOTTOM_SPACING = '1000';
export const LearningContentPageLayout = ({
  header,
  navigation,
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(View, {
    paddingBlockEnd: navigation || isMobile ? undefined : BOTTOM_SPACING,
    children: [header, navigation ? /*#__PURE__*/_jsxs(TFlex, {
      flexDirection: isMobile ? 'column-reverse' : 'row',
      children: [navigation, /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        marginBlockEnd: BOTTOM_SPACING,
        children: children
      })]
    }) : children]
  });
};
export default LearningContentPageLayout;